"use client"

import { motion } from "framer-motion"
import CarCard from '../../Ui/ImageCard'

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.18,
    },
  },
}

const rowVariants = {
  hidden: { opacity: 0, y: 70 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.85,
      ease: [0.22, 1, 0.36, 1],
    },
  },
}

export default function CarShowcase() {
  return (
    <motion.section
      className="bg-[#050508] flex flex-col gap-[3px] p-[3px]"
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-60px" }}
    >
      {/* Row 1 — Full width hero */}
      {/* Row 1 — Full width hero (Bentley) */}
      <motion.div variants={rowVariants}>
        <CarCard
          src="/assets/cars/bent.jpg"
          title="Bentley"
          subtitle="Paint Protection Film"
          index="SYS·001"
          className="w-full aspect-[16/9] md:aspect-auto md:h-[520px] lg:h-[600px]"
        />
      </motion.div>

      {/* Row 2 — Two equal cards */}
      <motion.div variants={rowVariants} className="flex flex-col md:flex-row gap-[3px]">
        <CarCard
          src="/assets/cars/lamb.jpg"
          title="Lamborghini"
          subtitle="Performance Parts"
          index="SYS·002"
          objectPosition="center center"
          className="w-full md:w-auto md:flex-1 h-[300px] sm:h-[400px] md:h-[520px] lg:h-[600px]"
        />
        <CarCard
          src="/assets/cars/fer.jpg"
          title="Ferrari"
          subtitle="Painting & Ceramic"
          index="SYS·003"
          objectPosition="center center"
          className="w-full md:w-auto md:flex-1 h-[300px] sm:h-[400px] md:h-[520px] lg:h-[600px]"
        />
      </motion.div>

      {/* Row 3 — Full width closer */}
      <motion.div variants={rowVariants}>
  <CarCard
    src="/assets/cars/por.jpg"
    title="Porsche 911"
    subtitle="Maintanence"
    index="SYS·004"
    className="w-full aspect-[16/9] md:aspect-auto md:h-[500px]"
  />
</motion.div>

    </motion.section>
  )
}